"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuButton = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../../mantine-theme/src");
var MenuButton_styles_1 = __importDefault(require("./MenuButton.styles"));
function MenuButton(_a) {
    var _b;
    var children = _a.children, onHover = _a.onHover, hovered = _a.hovered, themeOverride = _a.themeOverride, elementRef = _a.elementRef, icon = _a.icon, color = _a.color, disabled = _a.disabled, rightSection = _a.rightSection, className = _a.className, others = __rest(_a, ["children", "onHover", "hovered", "themeOverride", "elementRef", "icon", "color", "disabled", "rightSection", "className"]);
    var classes = MenuButton_styles_1.default({ color: color, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement("button", __assign({ type: "button", role: "menuitem", className: clsx_1.default(classes.item, (_b = {}, _b[classes.hovered] = hovered, _b), className), onMouseEnter: function () { return !disabled && onHover(); }, ref: elementRef, disabled: disabled }, others),
        react_1.default.createElement("div", { className: classes.inner },
            icon && (react_1.default.createElement("div", { "data-mantine-icon": true, className: classes.icon }, icon)),
            react_1.default.createElement("div", { className: classes.body },
                react_1.default.createElement("div", { className: classes.label }, children),
                rightSection))));
}
exports.MenuButton = MenuButton;
MenuButton.displayName = '@mantine/core/MenuButton';
